import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles.css";

console.log("Main: Script execution started.");
const rootElement = document.getElementById("root");

if (!rootElement) {
  console.error("Main: #root element not found!");
  const errorDiv = document.createElement("div");
  errorDiv.style.color = "red";
  errorDiv.style.padding = "20px";
  errorDiv.innerText = "Fatal Error: #root element not found in the DOM.";
  document.body.appendChild(errorDiv);
} else {
  try {
    console.log("Main: Initializing React root...");
    ReactDOM.createRoot(rootElement).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    console.log("Main: React render call finished.");
  } catch (err) {
    console.error("Main: React render failed:", err);
    const errorDiv = document.createElement("div");
    errorDiv.style.color = "red";
    errorDiv.style.padding = "20px";
    errorDiv.innerText = "Fatal Error: Failed to render React tree. " + (err instanceof Error ? err.message : String(err));
    document.body.appendChild(errorDiv);
  }
}
